const NousSoutenirSlider = (target) => {
  const sliderParams = {
    infinite: false,
  };

  const initSlider = ($el, params) => {
    $el.slick(params);
  };
  $('body').find(target)
    .each((_, el) => {
      const $el = $(el);
      let controls = $el.data('slider-controls');
      const params = $.extend({}, sliderParams, $el.data('slider-params'))

      if (controls) {
        params.nextArrow = $(controls.nextArrowSelector);
        params.prevArrow = $(controls.prevArrowSelector);
      }

      initSlider($el, params);
    });
}

export default NousSoutenirSlider;



// WEBPACK FOOTER //
// ./scripts/components/NousSoutenirSlider.js